import { useFormContext } from '@sravni/cosago-react-library/lib/hooks';
import type { FocusEvent } from 'react';
import { useCallback } from 'react';

import { useValidateOnBlur } from 'shared/lib/useValidateOnBlur';

import type { TPassportFormFields } from 'entities/creditForm';

const LINKED_PASSPORT_VALIDATION_FIELDS: Array<keyof TPassportFormFields> = [
  'birthDate',
  'passportIssueDate',
  'passportNumber',
];

export const useValidatePassportLinkedFieldsOnBlur = (fieldName: string, isValidateEmptyValue = true) => {
  const { trigger } = useFormContext<TPassportFormFields>();
  const validateFieldOnBlur = useValidateOnBlur(fieldName, isValidateEmptyValue);

  return useCallback(
    (event?: FocusEvent<HTMLElement>) => {
      validateFieldOnBlur(event);

      const dependentFieldNames = LINKED_PASSPORT_VALIDATION_FIELDS.filter((name) => name !== fieldName);
      trigger(dependentFieldNames);
    },
    [fieldName, trigger, validateFieldOnBlur],
  );
};
